import React from 'react'
import { postUserDepartment, deleteUserDepartment } from 'api/users'
import { useModal, useSnackbar } from 'hooks'
import { t } from 'ttag'

const useDeleteDepartmentModal = (state, handlers) => {
  const { department } = state
  const { handleDeleteDepartment, setDepartment, updateTable } = handlers

  const { handleClose, handleOpen, isOpen } = useModal()

  const handleDeleteDepartmentAccessClose = React.useCallback(() => {
    handleClose()
    setDepartment(null)
  }, [handleClose, setDepartment])

  const handleDeleteDepartmentAccessConfirm = React.useCallback(() => {
    handleDeleteDepartment(
      { department },
      {
        postSuccessAction: () => {
          handleDeleteDepartmentAccessClose()
          updateTable()
        },
      },
    )
  }, [
    department,
    handleDeleteDepartment,
    handleDeleteDepartmentAccessClose,
    updateTable,
  ])

  return {
    handleDeleteDepartmentAccessClose,
    handleDeleteDepartmentAccessConfirm,
    handleDeleteDepartmentAccessOpen: id => {
      setDepartment(id)
      handleOpen(id)
    },
    isDeleteDepartmentAccessOpen: isOpen,
  }
}

export const useAdminPanel = ({ pk }) => {
  const [signalTableUpdate, setSignalTableUpdate] = React.useState(false)
  const [department, setDepartment] = React.useState(null)

  const {
    handlers: { handleShowSnackbar },
  } = useSnackbar()

  const updateTable = () => setSignalTableUpdate(!signalTableUpdate)

  const addUserDepartment = async departmentId => {
    const { response } = await postUserDepartment({
      pk,
      departmentId,
    })

    if (response) {
      updateTable()
      handleShowSnackbar({
        message: t`Department access was successfully added`,
        type: 'success',
      })
    }
  }

  const handleDeleteDepartment = async (
    { department },
    { postSuccessAction } = {},
  ) => {
    const { response } = await deleteUserDepartment({
      pk,
      departmentId: department,
    })

    if (response) {
      postSuccessAction()
      handleShowSnackbar({
        message: t`Department access was successfully removed`,
        type: 'success',
      })
    }
  }

  const {
    handleDeleteDepartmentAccessClose,
    handleDeleteDepartmentAccessConfirm,
    handleDeleteDepartmentAccessOpen,
    isDeleteDepartmentAccessOpen,
  } = useDeleteDepartmentModal(
    { department },
    { handleDeleteDepartment, setDepartment, updateTable },
  )

  return {
    state: {
      signalTableUpdate,
      isDeleteDepartmentAccessOpen,
    },
    handlers: {
      addUserDepartment,
      handleDeleteDepartmentAccessClose,
      handleDeleteDepartmentAccessConfirm,
      handleDeleteDepartmentAccessOpen,
    },
  }
}
